var _a;
import { createSlice } from '@reduxjs/toolkit';
import { sliceName } from '../../../constants';
import { vehicleRegistrationInitialState } from '../../initialStates';
var vehicleRegistrationSlice = createSlice({
    name: sliceName.vehicleRegistrationSliceName,
    initialState: vehicleRegistrationInitialState.initialvehicleRegistrationState,
    reducers: {
        setVehicleRegistration: function (state, action) {
            if (action.payload) {
                state.length > action.payload.length && state.splice(action.payload.length - 1);
                for (var i = 0; i < action.payload.length; i++) {
                    state[i] = action.payload[i];
                }
            }
        },
        deleteVehicleRegistration: function (state, action) {
            for (var i = 0; i < state.length; i++) {
                state[i].registrationId === action.payload && state.splice(i, 1);
            }
        },
        updateVehicleRegistration: function (state, action) {
            var _a = action.payload, carpoolStatus = _a.carpoolStatus, registrationId = _a.registrationId;
            for (var i = 0; i < state.length; i++) {
                if (state[i].registrationId === registrationId)
                    state[i].carpoolStatus = carpoolStatus;
            }
        },
    },
});
export var setVehicleRegistration = (_a = vehicleRegistrationSlice.actions, _a.setVehicleRegistration), updateVehicleRegistration = _a.updateVehicleRegistration, deleteVehicleRegistration = _a.deleteVehicleRegistration;
export var vehicleRegistrationReducer = vehicleRegistrationSlice.reducer;
